import { Button, Stack, Text, Box } from '@chakra-ui/react'
import { useFormik } from 'formik';
import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import * as Yup from 'yup';
import CustomInput from '../../form-components/CustomInput';
import { UseApi } from '../../../libraries/UseApi';
import { UseConstant } from '../../../libraries/UseConstant';
import { UserInfoContext } from '../../../provider/UserInfoProvider';

export default function SignInForm() {
    const { postApi } = UseApi();
    const { constant } = UseConstant();
    const navigate = useNavigate();
    const { setToken, setUserInfo } = useContext(UserInfoContext);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup.string().email('有効なメールアドレスを入力してください').required('メールアドレスは必須です'),
            password: Yup.string().required('パスワードは必須です'),
        }),
        onSubmit: (values) => {
            setIsLoading(true);
            postApi(
                `${process.env.REACT_APP_API_URL}/user/login`, values, {},
                (response) => {
                    setIsLoading(false);
                    if (response.isSuccess === false) {
                        return;
                    }
                    handleSignInResponse(response);
                }
            );
        }
    });

    const handleSignInResponse = (response) => {
        const {data} = response;
        const {user} = data;
        setToken(data.token);
        setUserInfo(user);

        if(user.is_first_login === constant.IS_FIRST_LOGIN) {
            navigate('/change-default-password');
        }else if(user.user_type === constant.USER_TYPE_ADMIN){
            navigate('/admin-dashboard');
        }else if(user.user_type === constant.USER_TYPE_USER || user.user_type === constant.USER_TYPE_EMPLOYEE) {
            navigate('/user-dashboard');
        } else {
            navigate('/test');
        }
    }

    return (
        <Box
            p={8}
            bg="rgba(255, 255, 255, 0.1)"
            backdropFilter="blur(20px)"
            borderRadius="3xl"
            boxShadow="0 8px 32px 0 rgba(251, 146, 60, 0.15)"
            border="1px solid rgba(255, 255, 255, 0.18)"
            position="relative"
            overflow="hidden"
            _before={{
                content: '""',
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '3px',
                bgGradient: 'linear(to-r, orange.400, pink.400, red.400)',
            }}
        >
            <form onSubmit={formik.handleSubmit}>
                <Stack spacing={5}>
                    <CustomInput
                        formik={formik}
                        label={'メールアドレス'}
                        type={'email'}
                        name={'email'}
                        id={'email'}
                        placeholder={'メールアドレスを入力'}
                        required={true}
                        bg="rgba(255, 255, 255, 0.9)"
                        border="2px solid transparent"
                        _hover={{ 
                            bg: "rgba(255, 255, 255, 1)",
                            borderColor: 'orange.300' 
                        }}
                        _focus={{ 
                            borderColor: 'orange.400',
                            boxShadow: '0 0 0 3px rgba(251, 146, 60, 0.1)',
                            bg: "rgba(255, 255, 255, 1)"
                        }}
                        borderRadius="xl"
                        height="14"
                        fontSize="md"
                        fontWeight="500"
                    />
                    
                    <CustomInput
                        formik={formik}
                        label={'パスワード'}
                        type={'password'}
                        name={'password'}
                        id={'password'}
                        placeholder={'パスワードを入力'}
                        required={true}
                        bg="rgba(255, 255, 255, 0.9)"
                        border="2px solid transparent"
                        _hover={{ 
                            bg: "rgba(255, 255, 255, 1)",
                            borderColor: 'orange.300' 
                        }}
                        _focus={{ 
                            borderColor: 'orange.400',
                            boxShadow: '0 0 0 3px rgba(251, 146, 60, 0.1)',
                            bg: "rgba(255, 255, 255, 1)"
                        }}
                        borderRadius="xl"
                        height="14"
                        fontSize="md"
                        fontWeight="500"
                    />

                    <Stack
                        direction={{ base: 'column', sm: 'row' }}
                        align={'start'}
                        justify={'space-between'}
                    >
                        <Link to={'/forgot-password'}>
                            <Text 
                                color={'orange.400'} 
                                fontWeight="600"
                                fontSize="sm"
                                _hover={{ 
                                    color: 'orange.500',
                                    textDecoration: 'underline' 
                                }}
                            >
                                パスワード忘れた?
                            </Text>
                        </Link>
                    </Stack>

                    <Button
                        bgGradient="linear(to-r, orange.400, red.500)"
                        color={'white'}
                        size="lg"
                        height="14"
                        fontSize="md"
                        fontWeight="700"
                        letterSpacing="wide"
                        _hover={{
                            bgGradient: 'linear(to-r, orange.500, red.600)',
                            transform: 'scale(1.02)',
                            boxShadow: '0 10px 40px rgba(251, 146, 60, 0.4)',
                        }}
                        _active={{
                            transform: 'scale(0.98)',
                        }}
                        type='submit'
                        isLoading={isLoading}
                        loadingText="サインイン中..."
                        borderRadius="xl"
                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        boxShadow="0 4px 20px rgba(251, 146, 60, 0.3)"
                    >
                        サインイン
                    </Button>
                </Stack>
            </form>
        </Box>
    )
}